import React, {useRef, RefObject} from 'react';
import {Link} from 'react-router-dom';
import AurAccordion, {
  AurAccordionRef,
} from '../../../common/aur-accordion/AurAccordion';
import AurAccordionGroup from '../../../common/aur-accordion/AurAccordionGroup';
import {AurButton} from '../../../common/aur-button/AurButton';

interface IUser {
  name: string;
  hobbies: string;
  favoriteAnimal: string;
  favoriteColor: string;
}

const users: IUser[] = [
  {
    name: 'Jane Doe',
    hobbies: 'Long walks on the beach, bungie jumping',
    favoriteAnimal: 'Cat',
    favoriteColor: 'Green',
  },
  {
    name: 'John Doe',
    hobbies: 'Knitting, kick boxing',
    favoriteAnimal: 'Dog',
    favoriteColor: 'Blue',
  },
  {
    name: 'Patty Doe',
    hobbies: 'Reading, mountain biking',
    favoriteAnimal: 'Otter',
    favoriteColor: 'Yellow',
  },
  {
    name: 'Tommy Doe',
    hobbies: 'Dancing, cooking, race car driving',
    favoriteAnimal: 'Ferret',
    favoriteColor: 'Red',
  },
];

const Accordion: React.FC = () => {
  let allAreExpanded = true;
  const accordionRefs: RefObject<AurAccordionRef>[] = [];
  for (let i = 0; i < users.length; i++) {
    accordionRefs.push(useRef<AurAccordionRef>(null));
  }

  const toggle = () => {
    if (allAreExpanded) {
      for (const ref of accordionRefs) {
        ref.current?.collapse();
      }
    } else {
      for (const ref of accordionRefs) {
        ref.current?.expand();
      }
    }
    allAreExpanded = !allAreExpanded;
  };

  const titleContent = (
    <AurButton
      type="text"
      label="Expand/Collapse All"
      onClick={toggle}
      size="Small"
    />
  );

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Accordion</h1>
        <div>
          The Accordion component lets users show and hide sections of related
          content on a page.
        </div>

        <Link to="/demo">Return</Link>
        <hr />

        <div style={{marginBottom: '32px'}}>
          <h2>Standard</h2>
          <div style={{marginBottom: '16px'}}>
            <AurAccordion alertWarningIcon={false} title="Globex">
              Lorem ipsum
            </AurAccordion>
          </div>
          <div style={{marginBottom: '16px'}}>
            <AurAccordion alertWarningIcon={false} title="Globex" disabled>
              Lorem ipsum
            </AurAccordion>
          </div>
          <div style={{marginBottom: '16px'}}>
            <AurAccordion
              alertWarningIcon={false}
              title="Globex"
              titleContent={<>Hello</>}
              transparent
            >
              Lorem ipsum
            </AurAccordion>
          </div>
        </div>

        <div style={{marginBottom: '32px'}}>
          <h2>Full Width</h2>
          <div style={{marginBottom: '16px'}}>
            <AurAccordion alertWarningIcon={false} title="Globex" fullWidth>
              Lorem ipsum
            </AurAccordion>
            alertWarningIcon={false}
          </div>
          <div style={{marginBottom: '16px'}}>
            <AurAccordion
              alertWarningIcon={false}
              title="Globex"
              fullWidth
              disabled
            >
              Lorem ipsum
            </AurAccordion>
          </div>
          <div style={{marginBottom: '16px'}}>
            <AurAccordion
              alertWarningIcon={false}
              title="Globex"
              fullWidth
              transparent
            >
              Lorem ipsum
            </AurAccordion>
          </div>
        </div>
      </div>

      <div style={{marginBottom: '64px'}}>
        <h1>Accordion Group</h1>
        <div>
          The Accordion Group component lets users group related accordions.
        </div>

        <Link to="/demo">Return</Link>
        <hr />

        <div style={{marginBottom: '32px'}}>
          <h2>Standard</h2>
          <div style={{marginBottom: '16px'}}>
            <AurAccordionGroup title="Users">
              <AurAccordion alertWarningIcon={false} title="Marvel">
                <div>
                  The Avengers are comprised of:
                  <ul>
                    <li>Ironman</li>
                    <li>Thor</li>
                    <li>Captain America</li>
                    <li>The Hulk</li>
                  </ul>
                </div>
              </AurAccordion>
              <AurAccordion alertWarningIcon={false} title="DC">
                <div>
                  The Justice League is comprised of:
                  <ul>
                    <li>Batman</li>
                    <li>Superman</li>
                    <li>The Flash</li>
                    <li>Aquaman</li>
                  </ul>
                </div>
              </AurAccordion>
            </AurAccordionGroup>
          </div>
          <div style={{marginBottom: '16px'}}>
            <AurAccordionGroup title="Users" disabled>
              <AurAccordion alertWarningIcon={false} title="Marvel">
                <div>
                  The Avengers are comprised of:
                  <ul>
                    <li>Ironman</li>
                    <li>Thor</li>
                    <li>Captain America</li>
                    <li>The Hulk</li>
                  </ul>
                </div>
              </AurAccordion>
              <AurAccordion alertWarningIcon={false} title="DC">
                <div>
                  The Justice League is comprised of:
                  <ul>
                    <li>Batman</li>
                    <li>Superman</li>
                    <li>The Flash</li>
                    <li>Aquaman</li>
                  </ul>
                </div>
              </AurAccordion>
            </AurAccordionGroup>
          </div>
          <div style={{marginBottom: '16px'}}>
            <AurAccordionGroup title="Users" transparent>
              <AurAccordion alertWarningIcon={false} title="Marvel">
                <div>
                  The Avengers are comprised of:
                  <ul>
                    <li>Ironman</li>
                    <li>Thor</li>
                    <li>Captain America</li>
                    <li>The Hulk</li>
                  </ul>
                </div>
              </AurAccordion>
              <AurAccordion alertWarningIcon={false} title="DC">
                <div>
                  The Justice League is comprised of:
                  <ul>
                    <li>Batman</li>
                    <li>Superman</li>
                    <li>The Flash</li>
                    <li>Aquaman</li>
                  </ul>
                </div>
              </AurAccordion>
            </AurAccordionGroup>
          </div>
        </div>

        <div style={{marginBottom: '32px'}}>
          <h2>Full Width</h2>
          <div style={{marginBottom: '16px'}}>
            <AurAccordionGroup title="Users" fullWidth>
              <AurAccordion alertWarningIcon={false} title="Marvel">
                <div>
                  The Avengers are comprised of:
                  <ul>
                    <li>Ironman</li>
                    <li>Thor</li>
                    <li>Captain America</li>
                    <li>The Hulk</li>
                  </ul>
                </div>
              </AurAccordion>
              <AurAccordion alertWarningIcon={false} title="DC">
                <div>
                  The Justice League is comprised of:
                  <ul>
                    <li>Batman</li>
                    <li>Superman</li>
                    <li>The Flash</li>
                    <li>Aquaman</li>
                  </ul>
                </div>
              </AurAccordion>
            </AurAccordionGroup>
          </div>
          <div style={{marginBottom: '16px'}}>
            <AurAccordionGroup title="Users" fullWidth disabled>
              <AurAccordion alertWarningIcon={false} title="Marvel">
                <div>
                  The Avengers are comprised of:
                  <ul>
                    <li>Ironman</li>
                    <li>Thor</li>
                    <li>Captain America</li>
                    <li>The Hulk</li>
                  </ul>
                </div>
              </AurAccordion>
              <AurAccordion alertWarningIcon={false} title="DC">
                <div>
                  The Justice League is comprised of:
                  <ul>
                    <li>Batman</li>
                    <li>Superman</li>
                    <li>The Flash</li>
                    <li>Aquaman</li>
                  </ul>
                </div>
              </AurAccordion>
            </AurAccordionGroup>
          </div>
          <div style={{marginBottom: '16px'}}>
            <AurAccordionGroup title="Users" fullWidth transparent>
              <AurAccordion alertWarningIcon={false} title="Marvel">
                <div>
                  The Avengers are comprised of:
                  <ul>
                    <li>Ironman</li>
                    <li>Thor</li>
                    <li>Captain America</li>
                    <li>The Hulk</li>
                  </ul>
                </div>
              </AurAccordion>
              <AurAccordion alertWarningIcon={false} title="DC">
                <div>
                  The Justice League is comprised of:
                  <ul>
                    <li>Batman</li>
                    <li>Superman</li>
                    <li>The Flash</li>
                    <li>Aquaman</li>
                  </ul>
                </div>
              </AurAccordion>
            </AurAccordionGroup>
          </div>
        </div>

        <div style={{marginBottom: '32px'}}>
          <h2>Interactivity</h2>
          <div style={{marginBottom: '16px'}}>
            <AurAccordionGroup
              title="Users"
              titleContent={titleContent}
              fullWidth
            >
              {users.map((user, i) => (
                <AurAccordion
                  alertWarningIcon={false}
                  title={user.name}
                  ref={accordionRefs[i]}
                >
                  <div>
                    About me:
                    <ul>
                      <li>Hobbies: {user.hobbies}</li>
                      <li>Favorite Animal: {user.favoriteAnimal}</li>
                      <li>Favorite Color: {user.favoriteColor}</li>
                    </ul>
                  </div>
                </AurAccordion>
              ))}
            </AurAccordionGroup>
          </div>
        </div>
      </div>
    </>
  );
};

export default Accordion;
